export enum Ratio {
  FULL = 'FULL',
  RATIO = 'RATIO',
}

export type RatioType = keyof typeof Ratio;
